import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const MassageCenters = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Massage Center Management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default MassageCenters;
